import { Locations } from '../libs/GraphQL';
import { buildActiveSchemaIdSet, filterActiveFleet } from './schemaLifecycle';

// Feature-scoped cache of the active fleet roster, shared by the schema tools.
// The read tools (item prices, schema conditions, library counts, per-entry
// view) need only the active schema-id set; the assign tool needs the full
// location objects (region/market/cluster) for its picker. Both derive from a
// single cached fetch, so visiting the library warms the roster and opening the
// assign tool reuses it instead of re-paging the fleet. Scoped here — the
// app-wide Locations() is untouched.
//
// TTL is generous: the fleet changes on the order of days, so a few minutes of
// staleness is invisible and keeps a whole work session's navigation instant.
let fleetCache = null;
let fleetCachedAt = 0;
let inFlight = null;
const TTL_MS = 5 * 60 * 1000;

export const invalidateFleetCache = () => {
  fleetCache = null;
  fleetCachedAt = 0;
};

export async function getCachedFleet({ force = false } = {}) {
  if (!force && fleetCache && Date.now() - fleetCachedAt < TTL_MS) {
    return fleetCache;
  }
  if (!force && inFlight) {
    return inFlight;
  }
  inFlight = Locations({ count: 2500, status: ['LIVE', 'OFFLINE'] }).then(
    filterActiveFleet,
  );
  try {
    const result = await inFlight;
    fleetCache = result;
    fleetCachedAt = Date.now();
    return result;
  } finally {
    inFlight = null;
  }
}

export async function getActiveSchemaIdSet(options) {
  return buildActiveSchemaIdSet(await getCachedFleet(options));
}
